import {GatewaySignals} from '@models/adminstration/gateway/gateway-configuration/gateway-signals';

export class GatewayConfigurationRequest {
  configurationList: GatewaySignals [] = [];
}